import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import owlLogo from '../Assets/logo icon transparent background.png';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';

const ContactInfo = ({ icon: Icon, title, children }) => (
  <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
    <div className="flex items-center mb-4">
      <div className="p-2 bg-[#3DA3DC]/10 rounded-lg">
        <Icon className="w-6 h-6 text-[#3DA3DC]" />
      </div>
      <h3 className="ml-3 font-semibold text-[#1d2840]">{title}</h3>
    </div>
    <div className="text-gray-600">{children}</div>
  </div>
);

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <div className="w-full bg-white shadow-sm sticky top-0 z-50">
        <header className="container mx-auto px-4 flex justify-between items-center py-5">
          <Link to="/" className="flex items-center">
            <img src={owlLogo} alt="SuperOwl Logo" className="h-14 md:h-16 mr-3" />
            <span className="text-[#1d2840] text-2xl md:text-3xl font-bold">Super</span>
            <span className="text-[#3DA3DC] text-2xl md:text-3xl font-bold">Owl</span>
          </Link>
        </header>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-[#1d2840] mb-6">Contact Us</h1>
          
          <p className="text-gray-600 text-lg mb-12">
            At SuperOwl, we're here to help! Whether you have questions about our AI conversational chat, 
            need technical support, or want to share feedback, feel free to reach out.
          </p>

          <h2 className="text-2xl font-bold text-[#1d2840] mb-8">Get in Touch</h2>

          <div className="grid gap-6">
            <ContactInfo icon={MapPin} title="Address">
              #5/1 First Floor, New Thippasandra, HAL 3rd Stage, Bangalore - 560075
            </ContactInfo>

            <ContactInfo icon={Mail} title="Email">
              beautgroup@gmail.com
            </ContactInfo>

            <ContactInfo icon={Phone} title="Phone">
              +91 96118 96916
            </ContactInfo>

            <ContactInfo icon={Clock} title="Support Hours">
              <div className="space-y-2">
                <p>Monday – Friday: 10 AM – 6 PM (IST)</p>
                <p>Saturday – Sunday: Closed</p>
              </div>
            </ContactInfo>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
